
const config = {
};

export const scopes = ["offline_access", "User.Read.All", "Chat.Read", "ChatMessage.Read"]; // , "OnlineMeetingParticipant.Read.Chat"
export default config;
